<form [formGroup]="form" (ngSubmit)="onSubmit()" class="h-full w-full overflow-x-hidden overflow-y-auto flex flex-col items-center justify-start space-y-4">
    <div class="mt-6 mb-3">
        <h1 class="text-primary">¡Sigue avanzando!</h1>
    </div>

    @if (isLoadingData()) {
        <p class="text-sm text-gray-500 w-full text-center">Cargando tu información...</p>
    }
    
    @for (config of dataInputs(); track $index) {
        <app-input
            class="w-full"
            [config]="config"
            [timeoutSeconds]="0.6"
            (submitValue)="handleValue($event)"
            (fieldStateChange)="onFieldStateChange()"
        ></app-input>
    }

    @if (validationMessage()) {
        <p class="text-red-500 text-xs w-full text-center px-2">{{ validationMessage() }}</p>
    }

    <button class="btn-primary mb-6" [disabled]="!canContinue() || isSubmitting()" type="submit">
        {{ isSubmitting() ? 'Guardando...' : 'Continuar' }}
    </button>
</form>
